import React from "react";
import { Helmet } from "react-helmet";

function PrivacyPolicy() {
  return (
    <>
    
<Helmet>
        <title>OGTH Privacy Policy – Your Data & Privacy</title>
        <meta
          name="description"
          content="Learn how OGTH collects, uses, and protects your personal information when you interact with our website or programs. Your privacy matters to us."
        />
        <meta
          name="keywords"
          content="OGTH privacy policy, data protection, GDPR, user data, email privacy, newsletter subscription"
        />
        <meta property="og:title" content="OGTH Privacy Policy – Your Data & Privacy" />
        <meta property="og:description" content="Learn how OGTH collects, uses, and protects your personal information when you interact with our website or programs. Your privacy matters to us." />
        <meta property="og:image" content="https://yourdomain.com/path-to-privacy-image.jpg" />
        <meta property="og:url" content="https://yourdomain.com/privacy-policy" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

<div className='bg-gray-50'>
    <div className="max-w-4xl mx-auto px-6 py-12">
      <h1 className="text-3xl font-bold mb-6 text-brand">Privacy Policy</h1>

      <p className="mb-4 text-gray-700">
        At OGTH, your privacy is very important to us. This Privacy Policy explains how we collect, use, and protect your information when you visit our website or interact with our services.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4 text-brand">Information We Collect</h2>
      <p className="mb-4 text-gray-700">
        We may collect personal information such as your name, email address, and other contact details when you voluntarily submit them through forms on our website, including newsletter sign-ups.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4 text-brand">How We Use Your Information</h2>
      <p className="mb-4 text-gray-700">
        The information we collect is used to:
      </p>
      <ul className="list-disc list-inside mb-4 text-gray-700">
        <li>Send you newsletters and updates if you opt-in</li>
        <li>Respond to inquiries or requests</li>
        <li>Improve our website and services</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-4 text-brand">Sharing Your Information</h2>
      <p className="mb-4 text-gray-700">
        We do not sell or rent your personal information to third parties. We may share data with trusted service providers who help us operate our website, conduct business, or provide services to you.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4 text-brand">Cookies & Tracking</h2>
      <p className="mb-4 text-gray-700">
        Our website may use cookies and similar tracking technologies to enhance your browsing experience and analyze site usage. You can manage your cookie preferences through your browser settings.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4 text-brand">Your Rights</h2>
      <p className="mb-4 text-gray-700">
        You have the right to:
      </p>
      <ul className="list-disc list-inside mb-4 text-gray-700">
        <li>Access the personal information we hold about you</li>
        <li>Request corrections or deletion of your information</li>
        <li>Opt-out of marketing communications at any time</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-4 text-brand">Contact Us</h2>
      <p className="mb-4 text-gray-700">
        If you have questions about this Privacy Policy or how we handle your information, please contact us at: <br />
        <strong>Email:</strong> ogth.africa@gmail.com
      </p>

      <p className="mt-8 text-gray-500 text-sm">
        Last updated: March 2026
      </p>
    </div>
    </div>
    </>
  );
}

export default PrivacyPolicy;